<div class="access-denied">
  <mat-icon class="access-denied__icon">lock</mat-icon>
  <h2 class="access-denied__title">Access Denied</h2>
  <p class="access-denied__message">
    Your account does not have access to this organization. Please contact support.
  </p>
  <button mat-stroked-button (click)="goToHomepage()">Go to Homepage</button>
</div>
